import apiClient from './client';

/**
 * GET /api/cases/:caseNumber/graph
 * Returns Cytoscape-compatible graph elements for the case's connected component.
 */
export const fetchCaseGraph = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/graph`);
  return data; // GraphResponse: { elements: { nodes, edges }, prime_suspect_id, ... }
};
